export default __webpack_public_path__ + "static/media/fad-modrandom.346241e1.svg";